'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dateformat = {exports: {}};

(function (module, exports) {
function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj};}else {_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj};}return _typeof(obj)}(function(global){var _arguments=arguments;var dateFormat=function(){var token=/d{1,4}|D{3,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|W{1,2}|[LlopSZN]|"[^"]*"|'[^']*'/g;var timezone=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;var timezoneClip=/[^-+\dA-Z]/g;return function(date,mask,utc,gmt){if(_arguments.length===1&&kindOf(date)==="string"&&!/\d/.test(date)){mask=date;date=undefined;}date=date||date===0?date:new Date;if(!(date instanceof Date)){date=new Date(date);}if(isNaN(date)){throw TypeError("Invalid date")}mask=String(dateFormat.masks[mask]||mask||dateFormat.masks["default"]);var maskSlice=mask.slice(0,4);if(maskSlice==="UTC:"||maskSlice==="GMT:"){mask=mask.slice(4);utc=true;if(maskSlice==="GMT:"){gmt=true;}}var _=function _(){return utc?"getUTC":"get"};var _d=function d(){return date[_()+"Date"]()};var D=function D(){return date[_()+"Day"]()};var _m=function m(){return date[_()+"Month"]()};var y=function y(){return date[_()+"FullYear"]()};var _H=function H(){return date[_()+"Hours"]()};var _M=function M(){return date[_()+"Minutes"]()};var _s=function s(){return date[_()+"Seconds"]()};var _L=function L(){return date[_()+"Milliseconds"]()};var _o=function o(){return utc?0:date.getTimezoneOffset()};var _W=function W(){return getWeek(date)};var _N=function N(){return getDayOfWeek(date)};var flags={d:function d(){return _d()},dd:function dd(){return pad(_d())},ddd:function ddd(){return dateFormat.i18n.dayNames[D()]},DDD:function DDD(){return getDayName({y:y(),m:_m(),d:_d(),_:_(),dayName:dateFormat.i18n.dayNames[D()],short:true})},dddd:function dddd(){return dateFormat.i18n.dayNames[D()+7]},DDDD:function DDDD(){return getDayName({y:y(),m:_m(),d:_d(),_:_(),dayName:dateFormat.i18n.dayNames[D()+7]})},m:function m(){return _m()+1},mm:function mm(){return pad(_m()+1)},mmm:function mmm(){return dateFormat.i18n.monthNames[_m()]},mmmm:function mmmm(){return dateFormat.i18n.monthNames[_m()+12]},yy:function yy(){return String(y()).slice(2)},yyyy:function yyyy(){return pad(y(),4)},h:function h(){return _H()%12||12},hh:function hh(){return pad(_H()%12||12)},H:function H(){return _H()},HH:function HH(){return pad(_H())},M:function M(){return _M()},MM:function MM(){return pad(_M())},s:function s(){return _s()},ss:function ss(){return pad(_s())},l:function l(){return pad(_L(),3)},L:function L(){return pad(Math.floor(_L()/10))},t:function t(){return _H()<12?dateFormat.i18n.timeNames[0]:dateFormat.i18n.timeNames[1]},tt:function tt(){return _H()<12?dateFormat.i18n.timeNames[2]:dateFormat.i18n.timeNames[3]},T:function T(){return _H()<12?dateFormat.i18n.timeNames[4]:dateFormat.i18n.timeNames[5]},TT:function TT(){return _H()<12?dateFormat.i18n.timeNames[6]:dateFormat.i18n.timeNames[7]},Z:function Z(){return gmt?"GMT":utc?"UTC":(String(date).match(timezone)||[""]).pop().replace(timezoneClip,"").replace(/GMT\+0000/g,"UTC")},o:function o(){return (_o()>0?"-":"+")+pad(Math.floor(Math.abs(_o())/60)*100+Math.abs(_o())%60,4)},p:function p(){return (_o()>0?"-":"+")+pad(Math.floor(Math.abs(_o())/60),2)+":"+pad(Math.floor(Math.abs(_o())%60),2)},S:function S(){return ["th","st","nd","rd"][_d()%10>3?0:(_d()%100-_d()%10!=10)*_d()%10]},W:function W(){return _W()},WW:function WW(){return pad(_W())},N:function N(){return _N()}};return mask.replace(token,function(match){if(match in flags){return flags[match]()}return match.slice(1,match.length-1)})}}();dateFormat.masks={default:"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",paddedShortDate:"mm/dd/yyyy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:sso",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",expiresHeaderFormat:"ddd, dd mmm yyyy HH:MM:ss Z"};dateFormat.i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"],timeNames:["a","p","am","pm","A","P","AM","PM"]};var pad=function pad(val,len){val=String(val);len=len||2;while(val.length<len){val="0"+val;}return val};var getDayName=function getDayName(_ref){var y=_ref.y,m=_ref.m,d=_ref.d,_=_ref._,dayName=_ref.dayName,_ref$short=_ref["short"],_short=_ref$short===void 0?false:_ref$short;var today=new Date;var yesterday=new Date;yesterday.setDate(yesterday[_+"Date"]()-1);var tomorrow=new Date;tomorrow.setDate(tomorrow[_+"Date"]()+1);var today_d=function today_d(){return today[_+"Date"]()};var today_m=function today_m(){return today[_+"Month"]()};var today_y=function today_y(){return today[_+"FullYear"]()};var yesterday_d=function yesterday_d(){return yesterday[_+"Date"]()};var yesterday_m=function yesterday_m(){return yesterday[_+"Month"]()};var yesterday_y=function yesterday_y(){return yesterday[_+"FullYear"]()};var tomorrow_d=function tomorrow_d(){return tomorrow[_+"Date"]()};var tomorrow_m=function tomorrow_m(){return tomorrow[_+"Month"]()};var tomorrow_y=function tomorrow_y(){return tomorrow[_+"FullYear"]()};if(today_y()===y&&today_m()===m&&today_d()===d){return _short?"Tdy":"Today"}else if(yesterday_y()===y&&yesterday_m()===m&&yesterday_d()===d){return _short?"Ysd":"Yesterday"}else if(tomorrow_y()===y&&tomorrow_m()===m&&tomorrow_d()===d){return _short?"Tmw":"Tomorrow"}return dayName};var getWeek=function getWeek(date){var targetThursday=new Date(date.getFullYear(),date.getMonth(),date.getDate());targetThursday.setDate(targetThursday.getDate()-(targetThursday.getDay()+6)%7+3);var firstThursday=new Date(targetThursday.getFullYear(),0,4);firstThursday.setDate(firstThursday.getDate()-(firstThursday.getDay()+6)%7+3);var ds=targetThursday.getTimezoneOffset()-firstThursday.getTimezoneOffset();targetThursday.setHours(targetThursday.getHours()-ds);var weekDiff=(targetThursday-firstThursday)/(864e5*7);return 1+Math.floor(weekDiff)};var getDayOfWeek=function getDayOfWeek(date){var dow=date.getDay();if(dow===0){dow=7;}return dow};var kindOf=function kindOf(val){if(val===null){return "null"}if(val===undefined){return "undefined"}if(_typeof(val)!=="object"){return _typeof(val)}if(Array.isArray(val)){return "array"}return {}.toString.call(val).slice(8,-1).toLowerCase()};if((_typeof(exports))==="object"){module.exports=dateFormat;}else {global.dateFormat=dateFormat;}})(void 0);
}(dateformat, dateformat.exports));

var dateFormat = dateformat.exports;

var ISO8601_REGEX = /^(\d{4})-(?:(02)-(0[1-9]|[12]\d)|(0[469]|11)-(0[1-9]|[12]\d|30)|(0[13578]|1[02])-(0[1-9]|[12]\d|3[01]))T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.(\d{1,6}))?(Z|-(?:(?:0[0-9]|1[012]):00|0[39]:30)|\+(?:(?:0\d|1[0-4]):00|(?:0[3-69]|1[0]):30|0[58]:45|12:45))$/;
function containsDate(dateCollection, date) {
    var dateParts = dateFormat(date, 'yyyy-mm-dd').split('-');
    if (dateParts.length < 3) {
        return false;
    }
    var year = dateCollection[dateParts[0]];
    if (!year) {
        return false;
    }
    var month = year[dateParts[1]];
    if (!month) {
        return false;
    }
    var day = month[dateParts[2]];
    return day && day.length > 0;
}
function getFirstDateFromNow(dateCollection) {
    var now = new Date();
    // First check if now exists exactly and return it if present.
    if (containsDate(dateCollection, now)) {
        now.setHours(0, 0, 0, 0);
        return now;
    }
    // Otherwise return first date after now if present
    var yearKeys = Object.getOwnPropertyNames(dateCollection).sort();
    for (var _i = 0, yearKeys_1 = yearKeys; _i < yearKeys_1.length; _i++) {
        var year = yearKeys_1[_i];
        var months = dateCollection[year];
        var monthKeys = Object.getOwnPropertyNames(months).sort();
        for (var _a = 0, monthKeys_1 = monthKeys; _a < monthKeys_1.length; _a++) {
            var month = monthKeys_1[_a];
            var days = months[month];
            var dayKeys = Object.getOwnPropertyNames(days).sort();
            for (var _b = 0, dayKeys_1 = dayKeys; _b < dayKeys_1.length; _b++) {
                var day = dayKeys_1[_b];
                if (days[day] && days[day].length > 0) {
                    try {
                        return new Date(parseInt(year, 10), parseInt(month, 10), parseInt(day, 10));
                    }
                    catch (e) {
                        // No-op - Ignore date if can't be parsed
                    }
                }
            }
        }
    }
    // If non were found
    return null;
}
/**
 *  Helper to determine if a string is a valid iso8601 datetime string
 */
function isValidISO8601String(value) {
    // noinspection SuspiciousTypeOfGuard
    if (!value || typeof value !== 'string') {
        return false;
    }
    // Check format
    if (!ISO8601_REGEX.test(value)) {
        return false;
    }
    // Redundant check for creation
    var iso8601 = new Date(value);
    return iso8601.toString() !== 'Invalid Date';
    // TODO (Once tests are created, can be moved there and removed here!)
    // TEST VALUES
    // VALID BASIC
    // 2020-01-01T00:00:00+00:00
    // 2020-01-31T00:00:00+00:00
    // 2020-01-01T23:59:59+00:00
    // 2020-04-30T00:00:00+00:00
    // 2020-07-31T00:00:00+00:00
    // 2020-08-31T00:00:00+00:00
    // 2020-09-30T00:00:00+00:00
    // 2020-12-31T00:00:00+00:00
    //
    // VALID WITH MS
    // 2020-01-01T00:00:00.0+00:00
    // 2020-01-01T00:00:00.000+00:00
    // 2020-01-01T00:00:00.000000+00:00
    // 2020-01-01T23:59:59.999999+00:00
    // 2020-01-31T00:00:00.000000+00:00
    // 2020-01-01T23:59:59.000000+00:00
    // 2020-04-30T00:00:00.000000+00:00
    // 2020-07-31T00:00:00.000000+00:00
    // 2020-08-31T00:00:00.000000+00:00
    // 2020-09-30T00:00:00.000000+00:00
    // 2020-12-31T00:00:00.000000+00:00
    //
    // INVALID YEARS
    // 20-01-01T00:00:00.000000+00:00
    //
    // INVALID MONTHS
    // 2020-1-01T00:00:00.000000+00:00
    // 2020-13-01T00:00:00.000000+00:00
    // 2020-00-01T00:00:00.000000+00:00
    //
    // INVALID DAYS
    // 2020-01-1T00:00:00.000000+00:00
    // 2020-01-00T00:00:00.000000+00:00
    // 2020-01-32T00:00:00.000000+00:00
    // 2020-03-32T00:00:00.000000+00:00
    // 2020-04-31T00:00:00.000000+00:00
    // 2020-12-32T00:00:00.000000+00:00
    // 2020-07-32T00:00:00.000000+00:00
    //
    // FEBRUARY
    // 2020-02-29T00:00:00.000000+00:00
    // 2020-02-30T00:00:00.000000+00:00
    //
    // INVALID TIME
    // 2020-01-01T1:01:01.000000+00:00
    // 2020-01-01T01:1:01.000000+00:00
    // 2020-01-01T01:01:1.000000+00:00
    // 2020-01-01T24:00:00.000000+00:00
    // 2020-01-01T23:60:00.000000+00:00
    // 2020-01-01T23:00:60.000000+00:00
    // 2020-01-01T-00:00:00.000000+00:00
    // 2020-01-01T00:-00:00.000000+00:00
    //
    // VALID TIMEZONE OFFSETS
    // 2020-01-01T00:00:00Z
    // 2020-01-01T00:00:00.000000Z
    // 2020-01-01T00:00:00.000000-12:00
    // 2020-01-01T00:00:00.000000-11:00
    // 2020-01-01T00:00:00.000000-10:00
    // 2020-01-01T00:00:00.000000-09:30
    // 2020-01-01T00:00:00.000000-09:00
    // 2020-01-01T00:00:00.000000-08:00
    // 2020-01-01T00:00:00.000000-07:00
    // 2020-01-01T00:00:00.000000-06:00
    // 2020-01-01T00:00:00.000000-05:00
    // 2020-01-01T00:00:00.000000-04:00
    // 2020-01-01T00:00:00.000000-03:30
    // 2020-01-01T00:00:00.000000-03:00
    // 2020-01-01T00:00:00.000000-02:00
    // 2020-01-01T00:00:00.000000-01:00
    // 2020-01-01T00:00:00.000000-00:00
    // 2020-01-01T00:00:00.000000+00:00
    // 2020-01-01T00:00:00.000000+01:00
    // 2020-01-01T00:00:00.000000+02:00
    // 2020-01-01T00:00:00.000000+03:00
    // 2020-01-01T00:00:00.000000+03:30
    // 2020-01-01T00:00:00.000000+04:00
    // 2020-01-01T00:00:00.000000+04:30
    // 2020-01-01T00:00:00.000000+05:00
    // 2020-01-01T00:00:00.000000+05:30
    // 2020-01-01T00:00:00.000000+05:45
    // 2020-01-01T00:00:00.000000+06:00
    // 2020-01-01T00:00:00.000000+06:30
    // 2020-01-01T00:00:00.000000+07:00
    // 2020-01-01T00:00:00.000000+08:00
    // 2020-01-01T00:00:00.000000+08:45
    // 2020-01-01T00:00:00.000000+09:00
    // 2020-01-01T00:00:00.000000+09:30
    // 2020-01-01T00:00:00.000000+10:00
    // 2020-01-01T00:00:00.000000+10:30
    // 2020-01-01T00:00:00.000000+11:00
    // 2020-01-01T00:00:00.000000+12:00
    // 2020-01-01T00:00:00.000000+12:45
    // 2020-01-01T00:00:00.000000+13:00
    // 2020-01-01T00:00:00.000000+14:00
    //
    // INVALID TIMEZONE OFFSETS
    // 2020-01-01T00:00:00.000000-12:01
    // 2020-01-01T00:00:00.000000-13:00
    // 2020-01-01T00:00:00.000000-10:45
    // 2020-01-01T00:00:00.000000+12:01
    // 2020-01-01T00:00:00.000000+15:00
    // 2020-01-01T00:00:00.000000+10:45
    // 2020-01-01T00:00:00.000000+1:00
    // 2020-01-01T00:00:00.000000+00:3
}
/**
 *  Verify and cast the value to a Date instance
 */
function ensureDateInstance(value) {
    if (!(value instanceof Date)) {
        if (!isValidISO8601String(value)) {
            return null;
        }
        return new Date(value);
    }
    return value;
}

exports.containsDate = containsDate;
exports.ensureDateInstance = ensureDateInstance;
exports.getFirstDateFromNow = getFirstDateFromNow;
exports.isValidISO8601String = isValidISO8601String;
//# sourceMappingURL=dates.js.map
